module.exports = __webpack_public_path__ + "static/slide9-743x573-81a679a16da7a7910c8feee82a6097ab.gif";